import React, { useEffect, useState } from "react";
import { Spin, Typography } from "antd";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { services } from "../../constants/Services";

import "./style.css";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

const { Text } = Typography;

const Dashboard = () => {
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  return (
    <div className="position-relative">
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-absolute top-0 start-0 w-100 h-100"
          style={{ backgroundColor: "rgba(255,255,255,0.7)", zIndex: 9999 }}
        >
          <Spin size="large" tip="Loading..." />
        </div>
      )}

      <Header />

      <div className="bg-light py-5 px-3  d-flex align-items-center justify-content-center">
        <div
          className="card  rounded-4 w-100"
          style={{ maxWidth: "1200px", minHeight: "800px" }}
        >
          <div className="card-body p-4">
            {/* SELL & EARN Title */}
            <div className="section-title mb-5">
              <span className="line"></span>
              <span className="text">SELL & EARN</span>
              <span className="line"></span>
            </div>

            <div className="row g-4">
              {services.map((service) => (
                <div
                  key={service.id}
                  className="col-6 col-sm-4 col-md-4 col-lg-4 d-flex flex-column align-items-center text-center"
                  onClick={() => {
                    navigate("/products", {
                      state: {
                        category_id: service.id,
                      },
                    });
                  }}
                >
                  <div
                    className="service-icon d-flex align-items-center justify-content-center mb-2"
                    style={{
                      width: 110,
                      height: 110,
                      borderRadius: "16px",
                      background: "linear-gradient(145deg, #f0f0f0, #d9d9d9)",
                      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.1)",
                      transition: "transform 0.3s ease",
                      cursor: "pointer",
                    }}
                  >
                    <img src={service.image} width={60} alt={service.title} />
                  </div>
                  <Text
                    strong
                    style={{
                      fontSize: "16px",
                      color: "#333",
                      // textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                  >
                    {service.title}
                  </Text>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Dashboard;
